import { CardContent, Grid } from '@mui/material';
import { formatCPF } from 'utils/formatters';
import { useStoreSelector } from 'v3/data/store';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { BodySmallRegularStyled, CardHeaderStyled, CardStyled, Content } from '../styles';

export const PersonalInformationInApp = () => {
  const { buyer } = useStoreSelector((store) => store.onlineContracting.paymentDetails);

  return (
    <CardStyled>
      <CardHeaderStyled
        title={
          <Content>
            <SubtitleLarge>Cliente</SubtitleLarge>
          </Content>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>Nome</BodySmallRegularStyled>
            <BodySmallRegular className="empty-line">{buyer.fullName}</BodySmallRegular>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <BodySmallRegularStyled>CPF</BodySmallRegularStyled>
            <BodySmallRegular className="empty-line">{buyer.cpf ? formatCPF(buyer.cpf) : ''}</BodySmallRegular>
          </Grid>
        </Grid>
      </CardContent>
    </CardStyled>
  );
};
